import { render, staticRenderFns } from "./ChartForKpi.vue?vue&type=template&id=ffb8f214&scoped=true&"
import script from "./ChartForKpi.vue?vue&type=script&lang=js&"
export * from "./ChartForKpi.vue?vue&type=script&lang=js&"
import style0 from "./ChartForKpi.vue?vue&type=style&index=0&id=ffb8f214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb8f214",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
